<div class="notes-component" >
    <p>
       <span [ngClass]="{'tip-title-toyota' : isToyotaTheme, 'tip-title-lexus' : !isToyotaTheme}">Tip: </span>
       <span [ngClass]="{'tip-content-toyota' : isToyotaTheme, 'tip-content-lexus' : !isToyotaTheme}">{{notes.content}}</span>
    </p>
 </div>